<template>
  <div class="details">
    <el-form :label-position="'right'" label-width="120px" :model="parameter">
      <el-form-item label="平台">
        <el-select v-model="parameter.platform_id" placeholder="请选择平台" style="margin-right: 10px;">
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="parameter.type" placeholder="请选择类型" style="margin-right: 10px;">
          <el-option
            v-for="item in [{id: 1, name: 'adq'}, {id: 2, name: 'mp'}, {id: 3, name: '头条'}]"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select
          v-model="parameter.order_type"
          placeholder="请选择订单类型"
          style="margin-right: 10px;"
          @change="change"
        >
          <el-option
            v-for="item in [{ 'type': 1, 'label': '公众号' }, { 'type': 2, 'label': '快应用' }]"
            :key="item.type"
            :label="item.label"
            :value="item.type"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="parameter.order_type === 1" label="公众号">
        <el-autocomplete
          v-model="parameter.app_name"
          style="width:200px"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelect"
        />
      </el-form-item>
      <el-form-item v-if="parameter.order_type === 2" label="推广链id">
        <el-input v-model="parameter.app_id" placeholder="请输入公众号名称" style="width: 200px;" />
      </el-form-item>
      <el-form-item v-if="parameter.order_type === 2" label="应用名称">
        <el-input v-model="parameter.app_name" placeholder="请输入应用名称" style="width: 200px;" />
      </el-form-item>
      <el-form-item label="满单量">
        <el-input v-model="parameter.callback_full" placeholder="大于0，并且大于漏单量" type="number" style="width: 200px;" />
      </el-form-item>

      <el-form-item label="漏单量">
        <el-input v-model="parameter.callback_not" placeholder="大于0，并且小于满单量" type="number" style="width: 200px;" />
      </el-form-item>
    </el-form>

    <div style=" display: flex;justify-content: end;">
      <el-button type="primary" @click="$emit('determine', parameter)">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getTheListOfOfficialAccount } from '@/api/releaseGroup.js'
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    currentItem: {
      default() {
        return {

        }
      }
    },

    platforms: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      parameter: {
        platform_id: this.currentItem.platform_id, // 平台
        type: this.currentItem.type, // 类型
        callback_full: this.currentItem.callback_full, // 满单量
        app_id: this.currentItem.app_id, // 公众号id（推广链id）
        app_name: this.currentItem.app_name, // 公众号名称(应用名称)
        callback_not: this.currentItem.callback_not, // 漏单量
        order_type: this.currentItem.order_type // 订单类型
      },
      order_name: this.currentItem.order_name
    }
  },

  methods: {
    getOfficialAccount() {

    },

    // 搜索公众号
    async querySearchAsync(name, cb) {
      const data = await getTheListOfOfficialAccount({ name: name || undefined })
      cb(data.data.list.map((item) => { return { ...item, value: item.account_name, address: item.app_id } }))
    },

    // 选中公众号
    handleSelect(item) {
      this.parameter.app_id = item.app_id
      this.parameter.app_name = item.account_name
    },
    // 选中公众号
    change(val) {
      // this.parameter.order_type === 2 ? this.parameter.app_name = '' : null
      // console.log('选择了========', val, this.parameter.order_type)
      if (val === 2) {
        this.parameter.app_name = ''
        this.parameter.app_id = ''
      }
    }
  }
}
</script>

<style scoped>

</style>
